import {
  getSummaryValue,
  makeExpEstHeaders,
  makeExpEstRow,
  getTitle,
  buildDisplayPairRow,
  makeFactorTable,
} from '../utils'

import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'

const modelSummaryMapper = (item, meta) => {
  const selectedValue = getSummaryValue(item?.selectedValue ?? item?.predicted, getTitle(meta))

  return {
    values: [selectedValue],
    tables: [
      {
        headers: makeExpEstHeaders(),
        rows: [makeExpEstRow(item?.experimental, item?.predicted, getTitle(meta))],
      },
    ],
  }
}

const modelDescriptorsMapper = (item, meta) => {
  const model = item?.predicted?.model
  const factorTable = makeFactorTable(model?.factors)

  return {
    tables: factorTable
      ? [
          {
            ...factorTable,
            footer: [buildDisplayPairRow(getTitle(meta), model?.logKow)],
          },
        ]
      : null,
  }
}

const logKow = (items) => {
  const item = items?.find((item) => item?.property === 'logKow')
  const meta = findEpiSuiteGroupById('logKow')

  return {
    title: getTitle(meta),
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: modelSummaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item, meta),
    modelOutput: item?.predicted?.model?.output,
  }
}

export { logKow }
